
import { Component, Vue, Watch } from 'vue-property-decorator';
import QvInput from '@/components/FormComponents/QvInput.vue';
import QvSelect from '@/components/FormComponents/QvSelect.vue';
import { ValidationObserver } from 'vee-validate';
import {
  CommonStore,
  MapStore,
  SensorStore,
  FarmStore,
  BlockStore
} from '@/store/modules';
import LocationInputMap from '@/components/Forms/Components/LocationInputMap.vue';
import {
  BlockSensorHistory,
  SensorLocation,
  SensorLocationHistory
} from '@/store/models/sensor';
import { Coordinate } from 'ol/coordinate';
import helpers from '@/utils/helpers';

@Component({
  components: {
    ValidationObserver,
    QvInput,
    QvSelect,
    LocationInputMap
  }
})
export default class BlockForm extends Vue {
  $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };
  sensorLocationId: number | null = null;

  get emptySensorLocation() {
    return SensorStore.emptySensorLocation;
  }
  get selectedFarmBlock() {
    return CommonStore.SelectedFarmBlock;
  }

  get sensorLocation() {
    return JSON.parse(JSON.stringify(SensorStore.AddEditSensorLocation));
  }

  set sensorLocation(sensorLocation: SensorLocation) {
    SensorStore.setAddEditSensorLocation(sensorLocation);
  }
  get sensors() {
    // return FarmStore.FarmSensors.filter(x => x.farm == this.farm).map(x => {
    //   return { value: x.sensorId, label: x.sensorName };
    // });
    return SensorStore.Sensors.map(x => {
      return {
        value: x.id,
        label: x.sensorId
      };
    });
  }

  get blocks() {
    return BlockStore.SimpleBlocks.filter(x => x.farm == this.farm).map(x => {
      return { value: x.id, label: x.name };
    });
  }

  get submitLabel() {
    if (
      this.sensorLocation &&
      this.sensorLocation.id &&
      this.sensorLocation.id != 0
    ) {
      return 'Update';
    }
    return 'Add';
  }

  @Watch('selectedFarmBlock', { deep: true })
  onSelectedFarmBlockChange() {
    if (this.$route.params.sensorLocationId) {
      this.farm = this.selectedFarmBlock.farmId;
    }
  }

  deleteDialog = false;

  farm: number | null = null;
  blockId: number | null = null;
  get farms() {
    return FarmStore.Farms.map(x => {
      return { value: x.id, label: x.name, pointGeom: x.pointGeom };
    });
  }
  farmPosition: null | Coordinate = null;

  sensorId: number | null = null;

  onFarmSelect(farmId: number) {
    const farm = this.farms.find(x => x.value == farmId);
    if (farm && farm.pointGeom) {
      if (typeof farm.pointGeom != 'string') {
        this.farmPosition = farm.pointGeom.coordinates as Coordinate;
        return;
      }
    }
    this.farmPosition = null;
  }

  async onSubmit() {
    if (this.sensorLocation.id && this.sensorLocation.id != 0) {
      await SensorStore.updateSensorLocation(this.sensorLocation);
      this.$router.push({
        name: 'SensorLocationList'
      });
      this.$q.notify({
        message: 'Sensor Location updated successfully',
        type: 'positive'
      });
    } else {
      if (this.sensorId) {
        this.sensorLocation.sensorLocationHistories = [
          { sensorId: this.sensorId }
        ] as SensorLocationHistory[];
      }
      if (this.blockId) {
        this.sensorLocation.blockSensorHistories = [
          { block: this.blockId }
        ] as BlockSensorHistory[];
      }
      await SensorStore.createSensorLocation(this.sensorLocation);
      this.$router.push({
        name: 'SensorLocationList'
      });
      // this.$router.replace({
      //   name: 'EditSensorLocation',
      //   params: { sensorLocationId: String(this.sensorLocation.id) }
      // });
      this.$q.notify({
        message: 'Sensor Location added successfully',
        type: 'positive'
      });
    }
    MapStore.setUpdateMapAlbums(true);
  }

  onReset() {
    requestAnimationFrame(() => {
      this.sensorLocation = JSON.parse(
        JSON.stringify(this.emptySensorLocation)
      );
      this.$refs.observer.reset();
      CommonStore.changeView('map');
      MapStore.updateMapSize();

      setTimeout(() => {
        MapStore.stopUpdateAnimation();
      }, 600);
      this.$router.push({ name: 'SensorLocationList' });
    });
  }

  async onDelete() {
    this.deleteDialog = false;
    if (
      this.sensorLocation &&
      this.sensorLocation.id &&
      this.sensorLocation.id != 0
    ) {
      SensorStore.deleteSensorLocation(this.sensorLocation.id);
      this.$router.push({ name: 'SensorLocationList' });
    }
  }

  deleteSensorLocation() {
    this.deleteDialog = true;
  }

  async created() {
    this.sensorLocation = JSON.parse(JSON.stringify(this.emptySensorLocation));
    await helpers.fetchingDefaultFarm();
    this.onSelectedFarmBlockChange();
    BlockStore.getSimpleBlocks();
    if (this.$route.params.sensorLocationId) {
      // FarmStore.getAllFarmSensor();
      SensorStore.getSensors();
      this.sensorLocationId = Number(this.$route.params.sensorLocationId);
      await SensorStore.getSensorLocationById(this.sensorLocationId);
    } else {
      // await FarmStore.getAllFarmSensor();
      await SensorStore.getSensors();
      this.farm = this.selectedFarmBlock.farmId;
      this.onFarmSelect(this.farm);
    }
  }
}
